<template>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#collapse-${disposition.id}`"
      >
        <strong>{{ disposition.name }}</strong>
        <span class="ms-3 text-muted">
          ({{ disposition.items.length }} pozycji)
        </span>

        <span v-if="disposition.receiving_person">
          - dla {{ disposition.receiving_person }}
        </span>
      </button>
    </h2>

    <div
        :id="`collapse-${disposition.id}`"
        class="accordion-collapse collapse"
        :data-bs-parent="'#draftDispositionsAccordion'"
    >
      <div class="accordion-body">

        <!-- PANEL EDYCJI -->
        <div v-if="editMode" class="card border-primary mb-3">
          <div class="card-body">

            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Nazwa dyspozycji *</label>
                <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="editForm.name"
                />
                <div v-if="errors.name" class="text-danger mt-1">
                  {{ errors.name }}
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label">Osoba przyjmująca</label>
                <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="editForm.receiving_person"
                />
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2 mt-3">
              <button class="btn btn-secondary btn-sm" @click="cancelEdit">
                Anuluj
              </button>
              <button class="btn btn-primary btn-sm" @click="saveEdit">
                Zapisz
              </button>
            </div>

          </div>
        </div>

        <!-- ACTION BUTTONS -->
        <div class="d-flex justify-content-end gap-2 mb-3">
          <button
              class="btn btn-outline-secondary btn-sm"
              @click="startEdit"
              v-if="!editMode"
          >
            Edytuj dyspozycję
          </button>
          <button class="btn btn-outline-danger btn-sm" @click="remove">
            Usuń
          </button>
          <button class="btn btn-primary btn-sm" @click="$emit('execute', disposition)">
            Zrób dyspozycję
          </button>
        </div>

        <DraftDispositionItemsTable
            :dispositionId="disposition.id"
            :items="disposition.items"
            @refresh="$emit('refresh')"
        />

      </div>
    </div>
  </div>
</template>

<script>
import DraftDispositionItemsTable from './DraftDispositionItemsTable.vue';

export default {
  components: {DraftDispositionItemsTable},

  props: {
    disposition: {type: Object, required: true}
  },

  data() {
    return {
      editMode: false,
      editForm: {
        name: '',
        receiving_person: ''
      },
      errors: {}
    };
  },

  methods: {
    startEdit() {
      this.editMode = true;
      this.errors = {};

      this.editForm = {
        name: this.disposition.name,
        receiving_person: this.disposition.receiving_person || ''
      };
    },

    cancelEdit() {
      this.editMode = false;
      this.errors = {};
    },

    async saveEdit() {
      this.errors = {};

      if (!this.editForm.name.trim()) {
        this.errors.name = 'Nazwa jest wymagana';
        return;
      }

      try {
        await axios.put(
            route('draft-dispositions.update', {disposition: this.disposition.id}),
            this.editForm
        );

        this.editMode = false;

        this.$emit('refresh');

        this.$emit('toast', {
          type: 'success',
          message: 'Dyspozycja została zaktualizowana'
        });

      } catch (e) {
        this.$emit('toast', {
          type: 'error',
          message: 'Nie udało się zapisać zmian'
        });
      }
    },

    async remove() {
      if (!confirm('Usunąć całą dyspozycję?')) return;

      await axios.delete(
          route('draft-dispositions.destroy', {id: this.disposition.id})
      );

      this.$emit('refresh');
    }
  }
};
</script>
